module.exports = __webpack_public_path__ + "media/newstyle/images/icon-cart-white-a2c570acefcd05903692bf0ed6c98699.svg";